import React, { useState } from 'react';
import { Text } from "@geist-ui/core";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import { sanitizeMarkdown, hasMarkdown } from '../../../utils/markdownUtils';
import { getAssetUrl } from '../../../utils/assetUtils';

const ContentPanel = ({ currentScene, fontSize, description }) => {
  // Sanitize the description text if it exists
  const sanitizedDescription = description ? sanitizeMarkdown(description) : '';
  const hasMarkdownContent = hasMarkdown(sanitizedDescription);
  
  const [imageSrc, setImageSrc] = useState(
    currentScene && currentScene.content && currentScene.content.image
      ? getAssetUrl(currentScene.content.image, { forceWebP: true })
      : null
  );
  
  React.useEffect(() => {
    if (currentScene && currentScene.content && currentScene.content.image) {
      setImageSrc(getAssetUrl(currentScene.content.image, { forceWebP: true }));
    } else {
      setImageSrc(null);
    }
  }, [currentScene]);
  
  const handleImageError = () => {
    if (currentScene && currentScene.content && currentScene.content.image) {
      setImageSrc(getAssetUrl(currentScene.content.image, { forceWebP: false }));
    }
  };

  return (
    <div className="paper-wrapper">
      <div className="content-panel paper">
        <div className="paper-container">
          <div className="paper-content">
          {currentScene && currentScene.content && (
            <>
              {currentScene.content.image && (
                <div className="scene-map">
                  <img 
                    src={imageSrc} 
                    alt="Scene Map" 
                    onError={handleImageError}
                  />
                </div>
              )}
              {description && (
                <div className="scene-description" style={{ fontSize: `${fontSize}px` }}>
                  {hasMarkdownContent ? (
                    <ReactMarkdown
                      remarkPlugins={[remarkGfm]} 
                      rehypePlugins={[rehypeRaw, rehypeSanitize]}
                    >
                      {sanitizedDescription}
                    </ReactMarkdown>
                  ) : (
                    <Text p>{description}</Text>
                  )}
                </div>
              )}
            </>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentPanel;
